((g) => {
  var h,
    a,
    k,
    p = "The Google Maps JavaScript API",
    c = "google",
    l = "importLibrary",
    q = "__ib__",
    m = document,
    b = window;
  b = b[c] || (b[c] = {});
  var d = b.maps || (b.maps = {}),
    r = new Set(),
    e = new URLSearchParams(),
    u = () =>
      h ||
      (h = new Promise(async (f, n) => {
        await (a = m.createElement("script"));
        e.set("libraries", [...r] + "");
        for (k in g)
          e.set(
            k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
            g[k],
          );
        e.set("callback", c + ".maps." + q);
        a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
        d[q] = f;
        a.onerror = () => (h = n(Error(p + " could not load.")));
        a.nonce = m.querySelector("script[nonce]")?.nonce || "";
        m.head.append(a);
      }));
  d[l]
    ? console.warn(p + " only loads once. Ignoring:", g)
    : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
})({
  key: googleMapsApiKey,
  v: "weekly",
  // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
  // Add other bootstrap parameters as needed, using camel case.
});

export default function GoogleMap({ coordinates, name }) {
  let map;
  let markers;
  let pin;

  async function initMap() {
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement, advancedMarkers, PinElement } =
      await google.maps.importLibrary("marker");

    const average = (array) => array.reduce((a, b) => a + b) / array.length;

    const { ColorScheme } = await google.maps.importLibrary("core");

    map = new Map(document.getElementById("google-map-render"), {
      center: {
        lat: average(coordinates.map((c) => c.lat)),
        lng: average(coordinates.map((c) => c.lng)),
      },
      zoom: 13,
      mapId: "DEMO_MAP_ID",
      mapTypeId: "terrain",
      disableDefaultUI: true,
      // colorScheme: ColorScheme.DARK,
    });

    // for (let i = 0; i < advancedMarkers.length; i++) {
    //   pin = new PinElement({
    //       scale: 2.5,
    //       borderColor: "#137333",
    //   });
    //   markers.appendChild(pin.element);
    // }

    // The marker, positioned at Uluru
    coordinates.forEach((p) => {
      pin = new PinElement({
        scale: 0.75,
        borderColor: "var(--color-background)",
        background: "var(--color-accent)",
        glyphColor: "var(--color-background)",
        // glyph: 'S',
      });
      // markers.appendChild(pin.element);
      markers = new AdvancedMarkerElement({
        map: map,
        position: p,
        title: name,
        content: pin.element,
      });
    });
  }

  initMap();
  return <div id="google-map-render" style={{ height: "200px" }}></div>;
}
